module.exports = __webpack_public_path__ + "media/img/help_center/Student_Manage_Application_06-2901eb4dea455fb78d903dd8c4fda36b.jpg";